<template>
  <!-- Le résumé produits est long : on l'affiche sur une ligne tronquée, le
       détail complet reste accessible en survol. -->
  <span class="efactura-products" :title="params.value">{{ params.value || '—' }}</span>
</template>

<script>
export default {
  name: 'CellRendererProducts'
}
</script>

<style scoped>
.efactura-products {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
